<template>
  <div class="modal-sendverifyemail">
    <a-modal
      v-model="showModal"
      class="modal-SendVerifyEmail"
      crm_at="modal_sendverifyemail"
      centered
      :footer="null"
      :after-close="SendVerifyEmailClose"
    >
      <div :class="currentLocale">
        <div class="row">
          <div class="col-12 modal-img-email">
            <div class="email-svg">
              <img
                crm_at="email_images"
                src="@/assets/images/basic_mail.svg"
                alt="email images"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <label
              class="email-title"
              :class="[currentLocale == 'th' ? 'th' : 'en']"
              crm_at="label_please_verify_email"
            >
              {{ lbl.verify.please_verify_email }}
            </label>
          </div>
          <div class="col-12 text-center pd-btn">
            <a-button
              type="primary"
              shape="round"
              class="btn-crm-xl h-40"
              crm_at="btn_submit"
              :style="{
                'background-color': backgroundColor
                  ? backgroundColor
                  : '#1890ff',
                'border-color': backgroundColor ? backgroundColor : '#1890ff',
                color: textColor ? textColor : '#FFFFFF',
              }"
              @click="handleSubmit"
            >
              <span
                class="label-send-email"
                crm_at="label_send_verify_email"
                :style="{ color: textColor ? textColor : '#FFFFFF' }"
                >{{ lbl.verify.send_verify_email }}</span
              >
            </a-button>
          </div>
        </div>
      </div>
    </a-modal>

    <AlertError
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsLogin from '@/core/Account/service/BzbsLogin.js'
import AlertError from '@/components/Modal/AlertError'
import Locale from '@/helper/Locale.js'

export default {
  components: { AlertError },
  mixins: [CommonMixin],
  props: {
    show: Boolean,
  },
  data() {
    return {
      showModal: false,
      currentLocale: Locale.getLocale(),
      backgroundColor: '',
      textColor: '',
      showError: false,
      dataError: {},
    }
  },
  watch: {
    show(newVal) {
      if (newVal === true) {
        this.getCustomerStore().then(() => {
          this.genInfo(newVal)
        })
      }
    },
  },
  methods: {
    genInfo(isShow) {
      this.showModal = isShow
    },
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.genCustomerStore(res.data)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    genCustomerStore(data) {
      this.backgroundColor = data.StoreDetail.ButtonColor
      this.textColor = data.StoreDetail.ButtonTextColor
    },
    SendVerifyEmailClose() {
      this.showModal = false
      this.$emit('changeSendVerifyEmail', false)
    },
    handleSubmit() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsLogin.getVerifyEmail()
          .then(res => {
            this.handleLoading(false)
            if (res.data.success == true) {
              this.showModal = false
              this.$emit('changeSendVerifyEmail', false)
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showModal = false
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response ? error.response.data.error.message : '',
              textColor: this.textColor,
              backgroundColor: this.backgroundColor,
            }
            console.log('getVerifyEmail error', error)
            resolve(error)
          })
      })
    },
    //Error
    ChangeError(event) {
      this.showError = event
      this.dataError = {}
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';

.modal-SendVerifyEmail {
  .label-send-email {
    font-size: 16px;
  }
  .ant-modal-close-x {
    margin: 10px;
  }
  .h-40 {
    height: 40px;
  }

  .modal-img-email {
    text-align: -webkit-center;
    padding: 50px 0 24px 0;
  }
  .email-svg {
    height: 120px;
    width: 120px;
    border-radius: 50%;
    background-color: #f6f6f6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .email-svg img {
    width: 80px;
    height: 80px;
  }
  .email-title {
    margin-bottom: 8px !important;
    flex-grow: 0;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #424242;
  }

  .email-detail {
    flex-grow: 0;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.33px;
    color: #595959;
    padding: 0 25px;
  }
  .pd-btn {
    padding: 60px 0px 50px;
  }
}
</style>
